module.exports = __webpack_public_path__ + "img/7.aad46c65.jpg";